import { Fieldset as ChakraFieldset } from "@chakra-ui/react"
import * as React from "react"

export interface FieldsetProps extends ChakraFieldset.RootProps {
  legend?: React.ReactNode
  helperText?: React.ReactNode
  errorText?: React.ReactNode
}

export const Fieldset = React.forwardRef<HTMLFieldSetElement, FieldsetProps>(
  function Fieldset(props, ref) {
    const { legend, helperText, errorText, children, ...rest } = props
    return (
      <ChakraFieldset.Root ref={ref} {...rest}>
        {legend && (
          <ChakraFieldset.Legend>{legend}</ChakraFieldset.Legend>
        )}
        {helperText && (
          <ChakraFieldset.HelperText>{helperText}</ChakraFieldset.HelperText>
        )}
        <ChakraFieldset.Content>{children}</ChakraFieldset.Content>
        {errorText && (
          <ChakraFieldset.ErrorText>{errorText}</ChakraFieldset.ErrorText>
        )}
      </ChakraFieldset.Root>
    )
  },
)

export const FieldsetLegend = ChakraFieldset.Legend
export const FieldsetHelperText = ChakraFieldset.HelperText
export const FieldsetErrorText = ChakraFieldset.ErrorText
export const FieldsetContent = ChakraFieldset.Content
